import { useEffect } from "react";
import { useNavigate } from "react-router";
import UserManager from "../components/user-management";
import { getUserInfo } from "../utils/utils";

const UserManagement = () => {
  const navigate = useNavigate();
  const { role } = getUserInfo();

  useEffect(() => {
    if (role !== "ADMIN") {
      navigate("/dashboard-view");
    }
  }, [role, navigate]);

  return <UserManager />;
};

export default UserManagement;
